


































































































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import {
  ChevronDownIcon,
  Edit2Icon,
  Trash2Icon,
  // @ts-ignore
} from "vue-feather-icons";
import Request from "@/models/checkRequest/request";
import RequestService from "@/services/requestService";
import { DELETE_REQUEST, UPDATE_URL } from "@/store/mutation-types";

@Component({
  components: {
    ChevronDownIcon,
    Edit2Icon,
    Trash2Icon,
  },
  computed: {
    ...mapGetters("projects", ["requests"]),
    ...mapState("settings", ["availableHttpMethods"]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class UrlDetail extends Vue {
  // mapGetters + mapState
  activeRequestId!: string;
  requests!: Array<Request>;
  hasActiveSubscription!: boolean;

  get isRedirect(): boolean {
    if (this.activeRequest) {
      const statusCode = RequestService.GetFirstStatusCode(this.activeRequest);

      return statusCode >= 300 && statusCode < 400;
    }

    return false;
  }

  get activeRequest(): Request | undefined {
    if (this.$route.params.id) {
      const request = this.requests.find(
        (request) => request.id == this.$route.params.id
      );
      return request;
    }

    return new Request();
  }

  showUrlEditForm = false;
  hasBeenDiscarded = false;
  localUrl = "";

  @Ref("urlEditInput")
  urlEditInput!: HTMLInputElement;

  set httpMethodLocal(newValue) {
    if (this.activeRequest) {
      this.$store.commit("projects/setHttpMethod", {
        id: this.activeRequest.id,
        httpMethod: newValue,
      });
    }
  }

  get httpMethodLocal() {
    if (this.activeRequest) {
      return this.activeRequest.httpMethod;
    }
    return "";
  }
  checkUrl() {
    this.$store.dispatch("projects/send", this.activeRequest);
  }

  mounted() {
    //
    // Redirect to Dashboard if no Request has been found
    if (!this.activeRequest) {
      this.$router.push({ name: "Dashboard" });
    }
  }

  edit() {
    if (this.activeRequest) {
      this.localUrl = this.activeRequest.url;
      this.showUrlEditForm = true;
      this.hasBeenDiscarded = false;
      this.$nextTick(() => {
        this.urlEditInput.focus();
      });
    }
  }

  discardUrlEdit() {
    //
    // Close edit form
    this.showUrlEditForm = false;
    this.hasBeenDiscarded = true;
  }

  saveUrl() {
    if (this.activeRequest) {
      if (this.hasBeenDiscarded) return;
      //
      // Close the form
      this.showUrlEditForm = false;
      //
      // If the name wasn't changed, don't update
      if (this.localUrl !== this.activeRequest.url && this.localUrl !== "") {
        this.$store.commit(`projects/${UPDATE_URL}`, {
          id: this.activeRequest.id,
          url: this.localUrl,
        });
      }
    }
  }

  deleteUrl() {
    if (this.activeRequest) {
      this.$confirm(`Are you sure you want to delete this url?`, "Delete url", {
        confirmButtonText: "Yes, delete",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          if (this.activeRequest) {
            this.$store.commit(
              `projects/${DELETE_REQUEST}`,
              this.activeRequest.id
            );
          }
        })
        .catch(() => {
          // don't do anything, just handle the promise
        });
    }
  }
}
